"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
const base_ui_components_atoms__atoms_1 = require("@motorata/base-ui.components.atoms._atoms");
const Checkbox = (_a) => {
    var _b, _c, _d;
    var { name, error, children, value, rhf } = _a, rest = __rest(_a, ["name", "error", "children", "value", "rhf"]);
    const theme = (0, styled_components_1.useTheme)();
    return (react_1.default.createElement(Wrapper, Object.assign({}, rest),
        react_1.default.createElement(FormControlLabel_1.default, { control: react_1.default.createElement(Checkbox_1.default, Object.assign({}, rhf, { checked: value, sx: {
                    // @ts-ignore
                    "color": error ? (_b = theme === null || theme === void 0 ? void 0 : theme.color) === null || _b === void 0 ? void 0 : _b.red : (_c = theme === null || theme === void 0 ? void 0 : theme.color) === null || _c === void 0 ? void 0 : _c.second,
                    "&.Mui-checked": {
                        // @ts-ignore
                        color: (_d = theme === null || theme === void 0 ? void 0 : theme.color) === null || _d === void 0 ? void 0 : _d.primary,
                    },
                    "& .MuiSvgIcon-root": { fontSize: 20 },
                } })), label: children })));
};
exports.default = Checkbox;
const Wrapper = (0, styled_components_1.default)(base_ui_components_atoms__atoms_1.Box) `
  * {
    box-sizing: border-box;
    font-family: 'Poppins' !important;
  }
  
  .MuiFormControlLabel-root {
    margin-left: 0 !important;
    margin-right: 0 !important;
    align-items: flex-start;
  }

  .MuiCheckbox-root {
    padding: 0 !important;
    margin-right: 10px;
  }

  .MuiTypography-root {
    font-size: ${({ theme }) => theme.font.S};
    color: ${({ theme }) => theme.color.secondary};
    font-weight: ${({ theme }) => theme.font.light};

    a,
    span {
      color: ${({ theme }) => theme.color.primary};
    }
  }
`;
//# sourceMappingURL=Checkbox.js.map